import ErrorComponent from '@/components/error/error-component';
import CompleteRegistration from '@/pages/complete-registration/complete-registration';
import SentForgotPasswordEmail from '@/pages/forgot-password/sent-forgot-password-email';
import Login from '@/pages/login/login';
import UpdatePassword from '@/pages/update-password/update-password';
import { Navigate } from 'react-router-dom';
import TwoFactorAuthentication from '@/pages/login/two-factor-authentication';
import VerifyLogin from '@/pages/login/verify-login';
import ForgotPassword from '@/pages/forgot-password/forgot-password';

const GeneralRoutes = [
  {
    name: 'Home',
    path: '',
    index: true,
    element: <Navigate to="login" />,
    errorElement: <ErrorComponent />,
  },
  {
    name: 'Complete Registration',
    path: 'complete-registration/:id',
    element: <CompleteRegistration />,
    errorElement: <ErrorComponent />,
  },
  {
    name: 'Login',
    path: 'login',
    element: <Login />,
    errorElement: <ErrorComponent />,
  },
  {
    name: 'Two Factor Authentication',
    path: 'verify',
    element: <TwoFactorAuthentication />,
    errorElement: <ErrorComponent />,
  },
  {
    name: 'Two Factor Authentication',
    path: '/verify-email/:id',
    element: <VerifyLogin />,
    errorElement: <ErrorComponent />,
  },
  {
    name: 'Forgot Password',
    path: 'forgot-password',
    element: <ForgotPassword />,
    errorElement: <ErrorComponent />,
  },
  {
    name: 'Email Sent',
    path: 'email-sent',
    element: <SentForgotPasswordEmail />,
    errorElement: <ErrorComponent />,
  },
  {
    name: 'Update Password',
    path: 'reset-password/:token',
    element: <UpdatePassword />,
    errorElement: <ErrorComponent />,
  },
];

export default GeneralRoutes;
